"use strict";

export class GridItem {
  constructor() {
    //
  }
}
